<!-- Recursief knoop-sjabloon: rij (foto + omschrijving links, pijltje rechts) met daaronder een
     genest blok kinderen (.nav-children). Het nesten zorgt dat de wortel met één rand zijn hele
     subboom omsluit. Het kinder-blok klapt uit/in via de grid-rows-truc (0fr ⇄ 1fr) zodat de
     hoogte-animatie naar auto-hoogte loopt; de duur komt uit een CSS-var (zie .scss). -->
<ng-template #nodeTpl let-node>
  <div class="nav-subtree" [class.nav-box]="node.level === 0">
    <div class="nav-row" [class.is-group]="!node.entry" [class.is-root]="node.level === 0"
         [class.is-active]="isActive(node)" [class.has-toggle]="node.children.length > 0"
         [style.--depth]="node.level" [style.--indent]="groupIndent(node)">
      <div class="nav-content" (click)="rowClick(node)">
        @if (node.logo) {
          <app-logo [url]="node.logoUrl" [noClick]="true" [border]="true" />
        } @else if (node.image) {
          <app-image-box [guid]="node.photoGuid" [border]="true" />
        }
        <span class="nav-text">
          <span class="nav-label">{{ node.label }}</span>
          @if (node.sublabel) {
            <span class="nav-sublabel">{{ node.sublabel }}</span>
          }
        </span>
      </div>

      <button type="button" class="nav-toggle" [class.is-hidden]="!node.children.length"
              (click)="toggle(node, $event)" [attr.aria-expanded]="isExpanded(node)">
        <app-icon name="caret-left" class="nav-chevron" [class.is-open]="isExpanded(node)" />
      </button>
    </div>

    @if (node.children.length) {
      <div class="nav-children" [class.is-open]="isExpanded(node)">
        <div class="nav-children-inner">
          @for (child of node.children; track child.id) {
            <ng-container *ngTemplateOutlet="nodeTpl; context: { $implicit: child }" />
          }
        </div>
      </div>
    }
  </div>
</ng-template>

<!-- Vaste Home-link: altijd zichtbaar, klapt niet uit ⇒ domeinen blijven eronder zichtbaar. -->
@if (_showHome$$()) {
  <div class="nav-subtree nav-box">
    <div class="nav-row is-root is-home" [style.--depth]="0">
      <div class="nav-content" (click)="goHome()">
        <app-image-box [border]="false"><mat-icon class="nav-home-icon">home</mat-icon></app-image-box>
        <span class="nav-label">{{ _homeLabel }}</span>
      </div>
      <span class="nav-toggle is-hidden" aria-hidden="true"></span>
    </div>
  </div>
}

@if (_showAdmin$$()) {
  @for (root of _navHistory.adminTree$$(); track root.id) {
    <ng-container *ngTemplateOutlet="nodeTpl; context: { $implicit: root }" />
  }
}

@if (_showUser$$()) {
  @for (root of _navHistory.userTree$$(); track root.id) {
    <ng-container *ngTemplateOutlet="nodeTpl; context: { $implicit: root }" />
  }
}
